<script>
export default {
  name: "TablaDetalleDefault",
  render: function (createElement) {
    console.log('TablaDetalleDefault ',this.objeto);
    if (this.objeto.item !== null) {
      return createElement('ul', Object.entries(this.objeto.item).map(function (prop, index) {
        return createElement('li', prop[0] + ' : ' + prop[1])
      }))
    } else {
      return createElement('p', 'No hay detalles para mostrar')
    }
  },
  props: {
    objeto: Object
  },
  data() {
    return {
    }
  },
  methods: {
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/TablaDetalleDefault.vue